import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const Image = styled.img`
  margin-right: 1rem;
`

export const Text = styled.h2`
  color: #fff;
`
